import { render, staticRenderFns } from "./move.vue?vue&type=template&id=0d794806&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d794806",
  null
  
)

export default component.exports